import {
  apiAddCustomerLead,
  apiDeleteCustomerLead,
  apiGetCustomerLead,
  apiGetCustomerLeads,
  apiUpdateCustomerLead,
} from "@lib/api/customerLead";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useCustomerLeadQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "customer-lead",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const customerLeadQuery = useQuery({
    queryFn: () => apiGetCustomerLead(id, params),
    queryKey: queryKeys,
    enabled: !!id && !!enabled,
  });

  const customerLeadsQuery = useQuery({
    queryFn: () => apiGetCustomerLeads(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addCustomerLeadMutation = useMutation({
    mutationFn: apiAddCustomerLead,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.customerLead"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const updateCustomerLeadMutation = useMutation({
    mutationFn: apiUpdateCustomerLead,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.customerLead"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const deleteCustomerLeadMutation = useMutation({
    mutationFn: apiDeleteCustomerLead,
    mutationKey: queryKeys,
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.customerLead"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    customerLeadQuery,
    customerLeadsQuery,
    addCustomerLeadMutation,
    updateCustomerLeadMutation,
    deleteCustomerLeadMutation,
  };
};
